import { render, staticRenderFns } from "./Schedule.vue?vue&type=template&id=dc06d310&scoped=true&"
import script from "./Schedule.vue?vue&type=script&lang=ts&"
export * from "./Schedule.vue?vue&type=script&lang=ts&"
import style0 from "./Schedule.vue?vue&type=style&index=0&id=dc06d310&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc06d310",
  null
  
)

export default component.exports